import {
  INCOMPLETE_ORDERS_REQUESTED,
  INCOMPLETE_ORDERS_SUCCESS,
  ORDER_SHIPMENTS_REQUESTED,
  ORDER_SHIPMENTS_SUCCESS,
} from '../types';

const INITIAL_STATE = {
  orders: {},
  ordersPagination: {},
  searchingShipments: [],
  searchedShipments: {},
  isFetching: false,
  status: 'waiting',
  errors: null
};

const incompleteOrders = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case INCOMPLETE_ORDERS_REQUESTED:
      return Object.assign({}, state, {
        orders: {},
        ordersPagination: {},
        isFetching: true,
        status: 'requested',
        errors: null
      });

    case INCOMPLETE_ORDERS_SUCCESS:
      return Object.assign({}, state, {
        orders: action.payload.orders || {},
        ordersPagination: action.payload.order_pagination,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case ORDER_SHIPMENTS_REQUESTED:
      return Object.assign({}, state, {
        searchingShipments: [...state.searchingShipments, action.payload],
        searchedShipments: {}
      });

    case ORDER_SHIPMENTS_SUCCESS:
      newState.searchingShipments = state.searchingShipments.filter(item => item !== parseInt(action.payload.order_id));
      newState.searchedShipments[action.payload.order_id] = action.payload.shipments;
      return newState;

    default:
      return state;
  }
}

export default incompleteOrders;
